import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { RingLoader } from "react-spinners";
import NavBar from "components/SideBar/SideBar2";
import HeaderBar from "./HeaderBar";
import Table from "./Table";
import { useDispatch, useSelector } from "react-redux";
import { 
  getNotesData, 
  setSelectedNotes, 
  setSelectedRowNotes,
  setSelectedModule,
  setSelectedCategory,
  setDefaultEntity,
  setSelectedGstin,
  setSelectedPeriods,
  setSearch,
  setProfileData
} from "./action";
import { errorToastMessage } from "utils/errorToast";
import { COMMON_MSGS } from "Constant/Messages";

const Notes = (props) => {
  const dispatch = useDispatch();
  const [pageNo, setPageNo] = useState(1);
  const {
    loaderStatus,
    tableData,
    entityMasterList,
    defaultEntity,
    profileData,
    selectedGstin: storeSelectedGstin,
    selectedPeriods,
    selectedRowNotes,
    moduleIds,
    selectedModule,
    selectedCategory,
    search,
  } = useSelector((store) => store.notesReducer);
const isInSameFinancialYear = (monthsArray) => {
  // Check if monthsArray exists and is an array with at least one element
  if (!monthsArray || !Array.isArray(monthsArray) || monthsArray.length === 0) {
    return false;
  }

  // Define the start month of the financial year
  const startMonth = 4; // April

  // Extract the year and month from the first element of the array
  const firstMonthData = monthsArray[0]?.split('-');
  if (!firstMonthData || firstMonthData.length !== 2) {
    return false;
  }

  const [firstMonth, firstYear] = firstMonthData.map(Number);
  
  // Check if parsing was successful
  if (isNaN(firstMonth) || isNaN(firstYear)) {
    return false;
  }

  // Calculate the financial year based on the start month
  const financialYear = firstMonth >= startMonth ? `${firstYear}-${firstYear + 1}` : `${firstYear - 1}-${firstYear}`;

  // Check if all months in the array belong to the same financial year
  for (const month of monthsArray) {
    if (!month || typeof month !== 'string') {
      return false;
    }
    
    const monthData = month.split('-');
    if (monthData.length !== 2) {
      return false;
    }
    
    const [m, y] = monthData.map(Number);
    if (isNaN(m) || isNaN(y)) {
      return false;
    }
    
    if (!(m >= startMonth && `${y}-${y + 1}` === financialYear || m < startMonth && `${y - 1}-${y}` === financialYear)) {
      return false;
    }
  }
  return true;
};
  const handleSubmit = async (isToast = true, pageNum = 1,searchStr='') => {
    console.log("Submit clicked with data:", {
      selectedModule,
      defaultEntity,
      storeSelectedGstin,
      selectedCategory,
      selectedPeriods,
      search,
    });

    if (
      !selectedModule ||
      !defaultEntity ||
      storeSelectedGstin.length ===0||
      !selectedCategory ||
       !selectedPeriods ||
    selectedPeriods.length === 0
    ) {
       errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
      return;
    }

   // Add financial year validation
       if (!isInSameFinancialYear(selectedPeriods)) {
         errorToastMessage("All selected periods must be within the same financial year");
         return;
       }

    try {
      const result = await dispatch(
        getNotesData(
          storeSelectedGstin,
          selectedModule,
          defaultEntity,
          selectedCategory,
          selectedPeriods,
          searchStr,
          pageNum,
          isToast
        )
      );
      dispatch(setSelectedNotes([]));
      dispatch(setSelectedRowNotes([]));
      console.log("API Response:", result);
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };
  const handlePageClick = (value) => {
    setPageNo(value.selected + 1);
    handleSubmit(false, value.selected + 1);
  };

  // Clear selections and form data on component unmount
  useEffect(() => {
    return () => {
      // Clear table selections
      dispatch(setSelectedNotes([]));
      dispatch(setSelectedRowNotes([]));
      
      // Clear form selections
      dispatch(setSelectedModule(""));
      dispatch(setSelectedCategory(""));
      dispatch(setDefaultEntity(""));
      dispatch(setSelectedGstin([]));
      dispatch(setSelectedPeriods([]));
      dispatch(setSearch(""));
      dispatch(setProfileData([]));
    };
  }, []);


  
  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable
        pauseOnHover
      />
      <div className="sweet-loading">
        <RingLoader size={100} color={"#123abc"} loading={loaderStatus} />
      </div>
      <NavBar currentPage="Repository" module="notes" history={props.history}>
        <HeaderBar handleSubmit={handleSubmit} setPageNo={setPageNo} pageNo={pageNo}/>
        <Table handlePageClick={handlePageClick} pageNo={pageNo} handleSubmit={handleSubmit}/>
      </NavBar>
    </div>
  );
};

export default Notes;
